import _ from 'lodash';
import { log, Membership } from '@swiper/core';
import { DataFilesService } from './DataFilesService';

export class MembershipsService extends DataFilesService {

  get name() { return 'memberships'; }

  async get( id, params ) {
    const data = await super.get( id, params );
    return new Membership( data );
  }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
